





































































import { Component, Emit, Model, Prop, Watch, PropSync } from 'vue-property-decorator';
import Vue from 'vue';
import AppNavTreeAddEdit from '@/components/apps/AppsNavTreeAddEdit.vue';
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';

@Component({
    components: {
        AppNavTreeAddEdit,
        ConfirmationDialog
    },
})
export default class AppNavTreeAdditionalMenu extends Vue {

    @Prop({default:false,type:Boolean})
    appEmbed!: boolean;

    @Prop( {default:false, type:Boolean})
    mainApp!: boolean;

    private open = false;

    @PropSync('item', { type: Object })
    syncedItem!: any;


    @Emit("deleteMenu")
    private deleteMenu(){
        this.open = false;
    }
}
